import { ChatToolResult } from "src/base-components/Chat/ChatToolResult";
import {
  ToolApprovalStatusEnum,
  ToolUse,
  ToolUseStatusEnum,
  ToolUseTypeEnum,
} from "src/clients/copilot";

type Props = {
  toolUse: ToolUse;
};

const getDisplayConfig = (
  toolUse: ToolUse,
): { isSuccess: boolean; message: string } => {
  switch (toolUse.type) {
    case ToolUseTypeEnum.APPROVAL:
      if (
        (toolUse.status as unknown as ToolApprovalStatusEnum) ===
        ToolApprovalStatusEnum.APPROVED
      ) {
        return { isSuccess: true, message: "approved by you" };
      }
      return { isSuccess: false, message: "permission denied" };
    case ToolUseTypeEnum.RESULT:
      switch (toolUse.status) {
        case ToolUseStatusEnum.SUCCESS:
          return { isSuccess: true, message: "executed successfully" };
        case ToolUseStatusEnum.DENIED:
          return { isSuccess: false, message: "permission denied" };
        case ToolUseStatusEnum.ERROR:
          return { isSuccess: false, message: "execution failed" };
        default:
          return { isSuccess: false, message: "unknown status" };
      }
    default:
      return { isSuccess: false, message: "unknown status" };
  }
};

export const ToolApprovalResultCard: React.FC<Props> = ({ toolUse }) => {
  const { isSuccess, message } = getDisplayConfig(toolUse);

  return (
    <ChatToolResult
      isSuccess={isSuccess}
      message={message}
      toolName={toolUse.tool_name}
    />
  );
};
